// extracted by mini-css-extract-plugin
export var menuItem = "w_tW d_fZ d_bz d_bD d_bP d_bf";
export var menuItemSub = "w_tX d_Z d_bz d_bP";
export var menuMainLink = "w_tY d_f0 d_dB";
export var menuLink = "w_tZ d_f0 d_dB";
export var icon = "w_p9 d_bC d_bP";
export var divider = "w_t0 d_bC d_bP";
export var sublinks = "w_t1";
export var link = "w_mZ";
export var Link = "w_rD q_rD q_qV q_rd";